import React, { useState } from 'react';
import {
  Card,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Drawer,
  Space,
  Button
} from 'antd';
import { Template } from '../../../../interfaces/backend/Template';
import { TemplatesPOSTRequest } from '../../../../interfaces/backend/TemplatesPOSTRequest';
import TemplateCardContextMenu from '../TemplateCardContextMenu';
import styled from 'styled-components';
import { blue } from '@ant-design/colors';

const FormItem = Form.Item;
const { Text } = Typography;
type CallTemplate = Extract<Template, { channel: 'SMS' | 'CALL' }>; // without the | 'CALL', Extract does not work correctly

interface Props {
  template: CallTemplate;
  deleteTemplate: (channel: string, templateId: string) => Promise<void>;
  makeDefault: (channel: string, templateId: string) => Promise<void>;
  patchTemplate: (
    channel: string,
    templateId: string,
    params: Record<string, unknown>
  ) => Promise<void>;
  createTemplate: (
    channel: string,
    params: TemplatesPOSTRequest
  ) => Promise<void>;
  setTemplateBeingDuplicated: (template: Template) => void;
}
const CustomCard = styled(Card)`
  cursor: pointer;
  &:hover {
    border: 1px solid ${blue.primary};
    transition: border 0.3s ease;
  }
`;

const CallTemplateCard: React.FC<Props> = (props: Props) => {
  const [openedTemplateEditor, setOpenedTemplateEditor] =
    useState<CallTemplate>();
  const [form] = Form.useForm();
  const [saveTemplate, changeSaveTemplate] = useState(false);
  const generateActionButtons = (): JSX.Element[] => {
    const buttons = [
      <TemplateCardContextMenu
        template={props.template}
        setTemplateBeingDuplicated={props.setTemplateBeingDuplicated}
        makeDefault={props.makeDefault}
        deleteTemplate={props.deleteTemplate}
      />
    ];

    return buttons;
  };
  const onFinish = async (value: { text: string }) => {
    changeSaveTemplate(true);
    await props.patchTemplate(
      props.template.channel,
      props.template.templateId,
      {
        text: value.text
      }
    );
    changeSaveTemplate(false);
    setOpenedTemplateEditor(undefined);
  };
  return (
    <Col span={24} lg={12} xl={8}>
      <CustomCard
        title="Automated Call"
        actions={generateActionButtons()}
        onClick={() => {
          setOpenedTemplateEditor(props.template);
        }}
      >
        <Row gutter={[4, 4]}>
          <Col span={24}>
            <Text type="secondary">Call Script (Female / US voice):</Text>
          </Col>
          <Col span={24}>
            <Text>{props.template.text}</Text>
          </Col>
        </Row>
      </CustomCard>
      <Drawer
        destroyOnClose
        open={openedTemplateEditor ? true : false}
        onClose={() => setOpenedTemplateEditor(undefined)}
        title="Automated Call Template Editor"
        width={500}
        styles={{
          body: {
            paddingBottom: 80
          }
        }}
        extra={
          <Space>
            <Button
              loading={saveTemplate}
              onClick={() => {
                form.submit();
              }}
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
            <Button
              onClick={(): void => {
                setOpenedTemplateEditor(undefined);
              }}
            >
              Cancel
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          onFinish={(value) => {
            onFinish(value);
          }}
          layout="vertical"
        >
          <FormItem
            label="Text:"
            name="text"
            initialValue={props.template.text}
          >
            <Input.TextArea placeholder={props.template.text} autoSize />
          </FormItem>
        </Form>
      </Drawer>
    </Col>
  );
};

export default CallTemplateCard;
